import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import LoginPage from "./modules/login/views/Pages/LoginPage.jsx";
import App from "./views/layouts/App";
import ConfigRelanceClaimer from "./views/pages/ConfigRelanceClaimer";
import { connect } from "react-redux";
import { updateUser } from "./store/actions/authActions";
import ls from "localstorage-slim";
import { getToken } from "helpers/function.js";

class RouteApp extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    if (ls.get("token")) {
      this.props.updateUser();
      if (this._isMounted) {
        this.setState({ loading: false });
      }
    } else {
      this.setState({ loading: false });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    if (this.state.loading) {
      return <div>Loading...</div>;
    }
    const tokenData = getToken(window.location.href);

    return (
      <Router>
        <Switch>
          <Route exact path={`/forgot-password/${tokenData}`}>
            <LoginPage />
          </Route>
          <Route exact path={`/verify-2fa`}>
            <LoginPage />
          </Route>
          <Route path="/">
            {!this.props.user.token ? <LoginPage /> : <App />}
          </Route>
          <Route exact path="/settings/claimer-follow-up-config">
            <ConfigRelanceClaimer />
          </Route>
        </Switch>
      </Router>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = {
  updateUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteApp);
